import React from "react";
import { Box, InputBase, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  inputWithLabelContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: (props) => `${props.marginRight / 10}rem`,
  },

  inputContainer: {
    display: "flex",
    alignItems: "center",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  input: {
    height: (props) => (props.height ? props.height : 40),
    padding: "8px 1.2rem",

    display: "flex",
    alignItems: "flex-start",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    fontWeight: "400",
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    width: (props) => (props.width ? `${props.width / 10}rem` : "100%"),
  },

  input2: {
    height: (props) => (props.height ? props.height : 40),
    padding: "8px 1.2rem",

    display: "flex",
    alignItems: "flex-start",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    fontWeight: "400",
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    width: (props) => (props.width2 ? `${props.width2 / 10}rem` : "100%"),
    marginLeft: "8px",
  },
  label: {
    marginRight: "1.2rem",
    fontWeight: "500",
    fontSize: "1.2rem",
    lineHeight: "2.4rem",
  },
  inputRightText: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    marginLeft: "8px",
  },

  buttonExtra: {
    marginLeft: "2rem",
  },
}));

const InputWithHorizontalLabel = ({
  label,
  placeholder,
  placeholder2,
  value,
  value2,
  setValue,
  setValue2,
  height,
  width,
  width2,
  rightText,
  type,
  Button,
  Entered,
  maxValue1,
  marginRight,

}) => {
  const classes = useStyles({ height, width, width2,marginRight });

  return (
    <Box className={classes.inputWithLabelContainer}>
      <Typography className={classes.label}>{label}</Typography>

      {Entered && <Entered />}
      <Box className={classes.inputContainer}>
        <InputBase
          className={classes.input}
          value={value}
          onChange={(e) => {
            maxValue1
              ? e.target.value <= maxValue1 && setValue(e.target.value)
              : setValue(e.target.value);
          }}
          placeholder={placeholder}
          multiline={height}
          type={type}
        />
        {rightText && (
          <Typography className={classes.inputRightText}>
            {rightText}
          </Typography>
        )}

        {placeholder2 && (
          <InputBase
            className={classes.input2}
            value={value2}
            onChange={(e) => setValue2(e.target.value)}
            placeholder={placeholder2}
            multiline={height}
            type={type}
            step="100"
          />
        )}

        {Button && (
          <Box className={classes.buttonExtra}>
            <Button />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default InputWithHorizontalLabel;
